import { useMemo } from 'react'
import { Icon } from '@leroy-merlin-br/backyard-react'
import { UserOutline, BuildingOutline } from '@backyard-ui/icons'

import { useUserResources, useLoyaltyProfile } from 'shared/hooks'

import * as S from './styled'

const Avatar = ({ isSmall, maskColor = 'white' }) => {
  const { userResources, userControls } = useUserResources()
  const { loyaltyStatus } = useLoyaltyProfile()

  const isUserActiveOnLoyalty = useMemo(() => loyaltyStatus?.isActive(), [
    loyaltyStatus
  ])

  const renderAvatarInner = () => {
    if (!userControls.isLoggedIn) {
      return <Icon as={UserOutline} />
    }

    if (userResources?.isLegalUser) {
      return <Icon as={BuildingOutline} />
    }

    return <span>{userResources?.name?.[0]}</span>
  }

  return (
    <S.Wrapper
      isOnLoyalty={isUserActiveOnLoyalty}
      maskColor={maskColor}
      isSmall={isSmall}
    >
      {userResources?.picture ? (
        <S.UserImage
          src={userResources?.picture}
          alt={`Imagem de perfil de ${userResources?.name}`}
        />
      ) : (
        <S.UserIcon>{renderAvatarInner()}</S.UserIcon>
      )}
    </S.Wrapper>
  )
}

export default Avatar
